import React from 'react';
import Layout from '../../../components/ui/Layout';
import { useAuth } from '../../../components/context/AuthContext';
import { Link, useNavigate } from 'react-router-dom';
import PaginatedSupermarkets from './PaginatedSupermarkets';
import BreadcrumbNavigation from '../../../components/ui/BreadcrumbNavigation';
import { Button, Row, Col, Container } from 'react-bootstrap'; // Added Container

export default function SupermarketsPage() {
  const { userRole } = useAuth();
  const navigate = useNavigate();

  const breadcrumbItems = [
    { path: "/", label: "Home" },
    { path: "/admin", label: "Admin Panel" },
    { label: "Supermarkets Management" }
  ];

  return (
    <Layout>
      <Container className="mt-4 px-3">
        <Row className="align-items-center mb-1">
          <Col xs="auto">
            <Button variant="outline-secondary" onClick={() => navigate(-1)} className="mb-2">
              &larr; Go Back
            </Button>
          </Col>
          <Col>
            <BreadcrumbNavigation items={breadcrumbItems} />
          </Col>
        </Row>
        
        <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center mb-4">
          <h1 className="mb-3 mb-sm-0">Supermarkets Management</h1>
          {userRole === 'Admin' && (
            <Link to="/admin/hardware/create" className="btn btn-primary">
              Add Supermarket
            </Link>
          )}
        </div>
        
        <PaginatedSupermarkets />
      </Container>
    </Layout>
  );
}
